import { useEffect } from 'react';
import { business } from '../data/business';
import type { Lang } from '../types/content';
import type { SchemaObject } from '../utils/schema';

type PageMeta = {
  title: string;
  description: string;
  lang: Lang;
  schema: SchemaObject[];
};

export function usePageMeta({ title, description, lang, schema }: PageMeta) {
  const schemaJson = JSON.stringify(schema);

  useEffect(() => {
    document.title = title;
    setMeta('name', 'description', description);
    setMeta('property', 'og:title', title);
    setMeta('property', 'og:description', description);
    setMeta('property', 'og:type', 'website');
    setMeta('property', 'og:url', `${business.url}/`);
    setMeta('property', 'og:locale', lang === 'es' ? 'es_US' : 'en_US');
    setCanonical(`${business.url}/`);

    document.getElementById('page-structured-data')?.remove();
    const script = document.createElement('script');
    script.type = 'application/ld+json';
    script.id = 'page-structured-data';
    script.text = schemaJson;
    document.head.appendChild(script);

    return () => {
      script.remove();
    };
  }, [title, description, lang, schemaJson]);
}

function setMeta(attr: 'name' | 'property', key: string, content: string) {
  let el = document.head.querySelector<HTMLMetaElement>(`meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement('meta');
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute('content', content);
}

function setCanonical(href: string) {
  let el = document.head.querySelector<HTMLLinkElement>('link[rel="canonical"]');
  if (!el) {
    el = document.createElement('link');
    el.rel = 'canonical';
    document.head.appendChild(el);
  }
  el.href = href;
}
